"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _menuOptionsContainer = _interopRequireDefault(require("../../utils/common-portal/menu-options-container"));

var _fi = require("react-icons/fi");

var _constants = require("./constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.icon-wrapper {\n  width: fit-content;\n  height: fit-content;\n  cursor: pointer; }\n";
  var fileName = "compone_menu";
  var element = document.querySelector("style[data-sass-component='compone_menu']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var OverflowMenu = function OverflowMenu(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? _constants.defaultWidth : _ref$width,
      getOptionLabel = _ref.getOptionLabel,
      icon = _ref.icon,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showOptions = _useState2[0],
      setShowOptions = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      containerDimension = _useState4[0],
      setContainerDimension = _useState4[1];

  var iconRef = (0, _react.useRef)();

  var getContainerDimension = function getContainerDimension() {
    var rect = iconRef.current.getBoundingClientRect();
    var dimension = {
      top: rect.top,
      right: rect.right,
      bottom: rect.bottom,
      left: rect.left,
      height: rect.height
    };
    setContainerDimension(dimension);
  };

  var showAllOptions = function showAllOptions() {
    getContainerDimension();
    setShowOptions(!showOptions);
  };

  var clickHandler = function clickHandler(e) {
    onClick && onClick(e);
    showAllOptions();
  };

  var blurHandler = function blurHandler() {
    setShowOptions(false);
  };

  var selectOption = function selectOption(event, value) {
    event.stopPropagation();

    if (!Boolean(value.isDisabled)) {
      setShowOptions(false);
      onChange(event, value);
    }
  };

  var iconKeyDownHandler = function iconKeyDownHandler(event) {
    if (event.code === 'Enter') {
      showAllOptions();
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": 'icon-wrapper',
    className: _constants.classes.iconWrapper,
    ref: iconRef,
    onBlur: blurHandler,
    onClick: clickHandler,
    onKeyDown: iconKeyDownHandler,
    tabIndex: _constants.defaultTabIndex
  }, Boolean(icon) ? icon : /*#__PURE__*/_react.default.createElement(_fi.FiMoreVertical, {
    size: _constants.defaultIconSize
  })), showOptions && /*#__PURE__*/_react.default.createElement(_menuOptionsContainer.default, {
    portalContainerId: 'overflow-menu-options',
    options: options,
    getOptionLabel: getOptionLabel,
    containerDimension: containerDimension,
    onChange: selectOption,
    width: width
  }));
};

OverflowMenu.propTypes = {
  options: _propTypes.default.array.isRequired,
  onChange: _propTypes.default.func.isRequired,
  getOptionLabel: _propTypes.default.func.isRequired,
  icon: _propTypes.default.elementType,
  width: _propTypes.default.string,
  onClick: _propTypes.default.func
};
var _default = OverflowMenu;
exports.default = _default;